import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "client-page__header" }
const _hoisted_2 = { class: "client-page__header-person" }
const _hoisted_3 = { class: "client-page__header-person-name" }
const _hoisted_4 = { class: "client-page__header-person-date" }
const _hoisted_5 = { class: "client-page__header-options" }
const _hoisted_6 = {
  key: 2,
  class: "client-page__header-options-tags"
}
const _hoisted_7 = { class: "client-page__header-options-tags-item-name" }
const _hoisted_8 = {
  key: 1,
  class: "client-page__header-permition"
}
const _hoisted_9 = { class: "client-page__header-permition-label" }
const _hoisted_10 = { class: "client-page__client" }
const _hoisted_11 = { class: "client-page__client-icon-block" }
const _hoisted_12 = { class: "client-page__client-title" }
const _hoisted_13 = {
  key: 0,
  class: "client-page__client-name"
}
const _hoisted_14 = { class: "client-page__address" }
const _hoisted_15 = { class: "client-page__client-icon-block" }
const _hoisted_16 = { class: "client-page__address-title" }
const _hoisted_17 = {
  key: 2,
  class: "client-page__direction"
}
const _hoisted_18 = { class: "client-page__direction-header" }
const _hoisted_19 = { class: "client-page__direction-header-left" }
const _hoisted_20 = { class: "client-page__direction-header-title" }
const _hoisted_21 = {
  key: 0,
  class: "client-page__direction-header-right"
}
const _hoisted_22 = { class: "client-page__direction-header-right-debt" }
const _hoisted_23 = { class: "client-page__direction-cp-left" }
const _hoisted_24 = { class: "client-page__direction-cp-left-count" }
const _hoisted_25 = { class: "client-page__direction-cp-left-name" }
const _hoisted_26 = { style: {whiteSpace: 'nowrap'} }
const _hoisted_27 = { class: "client-page__direction-cp-right" }
const _hoisted_28 = { class: "client-page__direction-header-right-debt" }
const _hoisted_29 = {
  key: 3,
  class: "client-page__divider"
}
const _hoisted_30 = { class: "client-page__direction" }
const _hoisted_31 = { class: "client-page__direction-header" }
const _hoisted_32 = { class: "client-page__direction-header-left" }
const _hoisted_33 = { class: "client-page__direction-header-title" }
const _hoisted_34 = {
  key: 0,
  class: "client-page__direction-header-right"
}
const _hoisted_35 = { class: "client-page__direction-header-right-debt" }
const _hoisted_36 = { class: "client-page__direction-uc-left" }
const _hoisted_37 = { class: "client-page__direction-uc-left-count" }
const _hoisted_38 = { class: "client-page__direction-uc-left-name" }
const _hoisted_39 = { class: "client-page__direction-uc-left-address" }
const _hoisted_40 = { class: "client-page__direction" }
const _hoisted_41 = { class: "client-page__direction-header" }
const _hoisted_42 = { class: "client-page__direction-header-left" }
const _hoisted_43 = { class: "client-page__direction-header-title" }
const _hoisted_44 = {
  key: 0,
  class: /*@__PURE__*/_normalizeClass({
					'client-page__direction-body': true,
					'client-page__direction-body--aw': true
				})
}
const _hoisted_45 = { class: "client-page__direction-aw-left" }
const _hoisted_46 = { class: "client-page__direction-aw-left-count" }
const _hoisted_47 = {
  key: 3,
  class: "client-page__direction-aw-left-roles"
}
const _hoisted_48 = { class: "client-page__direction-aw-left-roles-item-name" }
const _hoisted_49 = {
  key: 4,
  class: "client-page__direction"
}
const _hoisted_50 = { class: "client-page__direction-header" }
const _hoisted_51 = { class: "client-page__direction-header-left" }
const _hoisted_52 = { class: "client-page__direction-header-title" }
const _hoisted_53 = {
  key: 0,
  class: "client-page__direction-body"
}
const _hoisted_54 = { class: "client-page__direction" }
const _hoisted_55 = {
  key: 0,
  class: "client-page",
  style: {"justify-content":"center","margin-top":"8px","max-height":"378px"}
}
const _hoisted_56 = { class: "client-page__direction" }
const _hoisted_57 = { class: "client-page__direction-permition" }
const _hoisted_58 = { class: "client-page__direction-permition-label" }

import {
	useRoute,
	useRouter
} from "vue-router";
import {
	computed,
	nextTick,
	onBeforeUnmount,
	onMounted,
	ref,
	watch
} from "vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";
import AppLoader from "@/components/common/AppLoader.vue";
import FileBlock from "@/components/main/project-block-page/file-block/FileBlock.vue";
import AppResizableDropdown from "@/components/ui-kit/dropdown/AppResizableDropdown.vue";
import ClientAddUnionDropdown from "@/components/main/client-block-page/dropdowns/ClientAddUnionDropdown.vue";
import ClientAddWorkerDropdown from "@/components/main/client-block-page/dropdowns/ClientAddWorkerDropdown.vue";
import ClientAddRoleDropdown from "@/components/main/client-block-page/dropdowns/ClientAddRoleDropdown.vue";
import DeleteClientConfirmDropdown from "@/components/main/client-block-page/dropdowns/DeleteClientConfirmDropdown.vue";
import ClientAddCounterpartyDropdown from "@/components/main/client-block-page/dropdowns/ClientAddCounterpartyDropdown.vue";
import DetachCounterpartyConfirmDropdown from "@/components/main/client-block-page/dropdowns/DetachCounterpartyConfirmDropdown.vue";
import CounterpartyInfoModal from "@/components/main/client-block-page/modals/CounterpartyInfoModal.vue";
import ClientInfoModal from "@/components/main/client-block-page/modals/ClientInfoModal.vue";
import HoldingExpandModal from "@/components/main/client-block-page/modals/HoldingExpandModal.vue";
import CounterpartiesExpandModal from "@/components/main/client-block-page/modals/CounterpartiesExpandModal.vue";
import { useOverflowDetection } from "@/composables/useOverflowDetection";
import AppScrollTopButton from "@/components/ui-kit/button/AppScrollTopButton.vue";
import { useScrollTopButton } from "@/composables/useScrollTopButton";
import AppTagSelector from "@/components/ui-kit/tag-selector/AppTagSelector.vue";
import FileInput from "@/components/file/FileInput.vue";
import InlineAddressEditor from "@/components/common/address-selector/InlineAddressEditor.vue";
import { AddressInputContainer } from "@/models/interfaces/entity-settings";
import { chainToRequestContainer, RequestAddressContainer } from "@/composables/useAddressRequest";
import ParametersSection from "@/components/main/shared/ParametersSection.vue";
import { V2ParameterAttachmentType } from "@/models/etc/parameter-types";
import { clientPageStore } from "@/store/client-page";
import { auxStore } from "@/store/auxillary";
import { favouritesStore } from "@/store/favourites";
import { TagEntityType } from "@/models/etc/types";
import { TagWithFrequency } from "@/models/interfaces/tags/tag-models";
import moment from "moment/moment";
import { workerStore } from "@/store/worker";
import { buildAbsoluteClientUrl } from "@/utils/urlHelpers";
import { copyTextToClipboard } from "@/utils/clipboard";
import { formatMoney } from "@/utils/format";
import { i18n } from "@/i18n";

const SHARE_TOOLTIP_KEY = 'ui_share'
const SHARE_COPIED_KEY = 'link_copied_to_clipboard'
const SHARE_COPIED_DELAY = 3000


export default /*@__PURE__*/_defineComponent({
  __name: 'ClientBlockPage',
  setup(__props) {

const clientStore = clientPageStore()
const favourStore = favouritesStore()
const workerStorage = workerStore();
const route = useRoute()
const router = useRouter()

const isClientLoading = computed(() => clientStore.clientLoading)
const isFavouritesLoading = computed(() => favourStore.isFavouritesLoading)
const clientId = computed(() => parseInt(route.query.id as string))
const client = computed(() => clientStore.openedClient)

const $clientPage = ref<HTMLElement | null>(null)
const { isScrollTopEnabled, scrollToTop } = useScrollTopButton(
	$clientPage,
	'.client-page__header',
	() => client.value?.Id
)

// Меню добавления параметра открывается из "+" в шапке блока «Параметры»
const parametersAddOpen = ref(false)
const parametersAddAnchor = ref<HTMLElement | null>(null)
const getTotalRevenue = computed(() => formatMoney(
	client.value
		? client.value.Counterparties.reduce((acc, cur) => acc + cur.Revenue, 0)
		: 0
))

const isAdmin = workerStorage.workerProfile?.IsAdmin;

const hasAnyRestrictedAccess = computed(() => {
  const c = clientStore.client;
  if (!c) return false;

  if (isAdmin) return false;

  return (
    c.AccessLevel === 0 ||
    c.NameAccess === 0 ||
    c.AttachedWorkersAccess === 0 ||
    c.AddressAccess === 0 ||
    c.UnionAccess === 0 ||
    c.RuleAccess === 0 ||
    c.ParameterAccess === 0 ||
    c.FileAccess === 0 ||
	c.CounterpartiesAccess === 0 ||
	c.JobAccess === 0 ||
	c.PersonAccess === 0 ||
	c.JobPreviousAccess === 0 ||
    c.DeleteAccess === 0
  );
});

const getTotalDebt = computed(() => formatMoney(
	client.value
		? client.value.Counterparties.reduce((acc, cur) => acc + cur.Debt, 0)
		: 0
))

// --- Раскрытие блоков на весь экран (модалки) ---
// Стрелка «на весь экран» показывается только когда тело блока переполнено
// и в нём появился скролл (см. useOverflowDetection).
const $holdingBody = ref<HTMLElement | null>(null)
const $cpBody = ref<HTMLElement | null>(null)
const $holdingModal = ref<InstanceType<typeof HoldingExpandModal> | null>(null)
const $cpModal = ref<InstanceType<typeof CounterpartiesExpandModal> | null>(null)

const { isOverflowing: isHoldingOverflowing } = useOverflowDetection(
	$holdingBody,
	() => client.value?.UnionClients?.length ?? 0,
)
const { isOverflowing: isCpOverflowing } = useOverflowDetection(
	$cpBody,
	() => client.value?.Counterparties?.length ?? 0,
)

const fetchClient = async () => {
	await clientStore.getClient(clientId.value)
}

const toggleFavourite = async () => {
	try {
		if (!isFavouritesLoading.value) {
			if (!client.value?.Favorite) {
				await favourStore.addFavourites(clientId.value, 0)
			} else {
				await favourStore.removeFavourites(clientId.value, 0)
			}
			clientStore.updateCurrentClientFavouriteState(!client.value?.Favorite)
		}
	} catch (error) {
		console.error(error)
	}
}

const $shareTooltip = ref<typeof AppTooltip | null>(null)

const shareTooltipKey = ref(SHARE_TOOLTIP_KEY)
const shareTooltipText = computed(() => String(i18n.global.t(shareTooltipKey.value)))

let shareTooltipTimer: ReturnType<typeof setTimeout> | null = null

const onCopyClientRoute = async () => {
	if (Number.isNaN(clientId.value)) {
		return
	}

	const copied = await copyTextToClipboard(
		buildAbsoluteClientUrl(`main?page=client&id=${clientId.value}`)
	)
	if (!copied) {
		return
	}

	if (shareTooltipTimer) {
		clearTimeout(shareTooltipTimer)
	}
	shareTooltipKey.value = SHARE_COPIED_KEY
	$shareTooltip.value?.showByClick()
	shareTooltipTimer = setTimeout(() => {
		shareTooltipKey.value = SHARE_TOOLTIP_KEY
		shareTooltipTimer = null
	}, SHARE_COPIED_DELAY)
}

onBeforeUnmount(() => {
	if (shareTooltipTimer) {
		clearTimeout(shareTooltipTimer)
	}
})

const getCreatedDate = (date: string) => moment(date).format("DD.MM.YYYY");

const $clientInfoModal = ref<InstanceType<typeof ClientInfoModal> | null>(null)

const $clientNameInput = ref<InstanceType<typeof FileInput> | null>(null)
const isClientNameEdited = ref(false)
const editedClientName = ref("")

const editClientName = () => {
	editedClientName.value = client.value?.Name ?? ""
	isClientNameEdited.value = true
	nextTick(() => $clientNameInput.value?.focus())
}

const saveClientName = async () => {
	isClientNameEdited.value = false
	const trimmed = editedClientName.value.trim()
	if (!trimmed || trimmed === client.value?.Name) return
	try {
		await clientStore.renameCurrentClient(trimmed)
	} catch (error) {
		console.error(error)
	}
}

const clientAddressContainer = computed<RequestAddressContainer | null>(() =>
	chainToRequestContainer({
		Components: client.value?.AddressComponents ?? [],
		ActiveLevel: 0,
	})
)

const onClientAddressSave = async (chain: AddressInputContainer) => {
	try {
		await clientStore.updateCurrentClientAddress(chain)
	} catch (error) {
		console.error(error)
	}
}

const openClientInfoModal = () => {
	$clientInfoModal.value?.onOpen(clientId.value, client.value?.Tags ?? [])
}

const $addTag = ref<typeof AppResizableDropdown | null>(null)

const clientTagsModel = computed<TagWithFrequency[]>(
	() => (client.value?.Tags ?? []) as unknown as TagWithFrequency[]
)

const onSelectorChange = async (nextTags: TagWithFrequency[]) => {
	const prevIds = new Set((client.value?.Tags ?? []).map(t => t.Id))
	const nextIds = new Set(nextTags.map(t => t.Id))

	const added = nextTags.filter(t => !prevIds.has(t.Id))
	const removedIds = [...prevIds].filter(id => !nextIds.has(id))

	try {
		for (const tag of added) await clientStore.attachTagToClient({ Name: tag.Name })
		for (const id of removedIds) await clientStore.detachTagFromClient(id)
	} catch (e) {
		console.error(e)
	}
}

const onCreateTag = async (name: string) => {
	try {
		await clientStore.attachTagToClient({ Name: name })
	} catch (e) {
		console.error(e)
	}
}

const onDetachTag = async (tagId: number) => {
	try {
		await clientStore.detachTagFromClient(tagId)
	} catch (e) {
		console.error(e)
	}
}

const $addUnionClient = ref<typeof AppResizableDropdown | null>(null)

const closeAddUnionDropdown = () => {
	$addUnionClient.value?.close()
}

const onDetachUnionClient = async (id: number) => {
	try {
		await clientStore.detachClientFromUnion(id)
	} catch (e) {
		console.error(e)
	}
}

const $addCounterparty = ref<typeof AppResizableDropdown | null>(null)
const $cpInfoModal = ref<InstanceType<typeof CounterpartyInfoModal> | null>(null)
const $cpDetach = ref<Record<number, any>>({})

const isCpInfoOpen = ref(false)

const openCpInfo = (counterpartyId: number) => {
	isCpInfoOpen.value = true
	$cpInfoModal.value?.onOpen(counterpartyId, canEditCounterparties.value)
}

const canEditCounterparties = computed(() =>
	clientStore.client?.CounterpartiesAccess == 2
)
const canViewCounterparties = computed(() =>
	clientStore.client?.CounterpartiesAccess !== 0
)

const counterpartyDropdownMode = ref<'search' | 'create'>('search')

const closeAddCounterpartyDropdown = () => {
	$addCounterparty.value?.close()
}

const onDetachCounterparty = async (id: number) => {
	try {
		await clientStore.detachCounterparty(id)
	} catch (e) {
		console.error(e)
	} finally {
		$cpDetach.value[id]?.close()
	}
}

const $addWorker = ref<typeof AppResizableDropdown | null>(null)

const closeAddWorkerDropdown = () => {
	$addWorker.value?.close()
}

const onDetachWorker = async (id: number) => {
	try {
		await clientStore.detachWorkerFromClient(id)
	} catch (e) {
		console.error(e)
	}
}

const $addRoles = ref<Record<number, any>>({})

const closeAddRoleDropdown = (awId: number) => {
	$addRoles.value[awId]?.close()
}

const onDetachRole = async (workerId: number, roleId: number) => {
	try {
		await clientStore.detachRoleFromWorker(workerId, roleId)
	} catch (e) {
		console.error(e)
	}
}

const $deleteClient = ref<InstanceType<typeof AppResizableDropdown> | null>(null)

const onConfirmDelete = async () => {
	if (isClientLoading.value) return
	try {
		await clientStore.deleteClient()
		await router.push({
			path: '/',
			query: {
				page: 'chat',
				mode: 'list',
			},
		})
	} catch (error) {
		console.error(error)
		$deleteClient.value?.close()
	}
}

watch(
	() => route.query.id,
	async (newVal, oldVal) => {
		if (newVal !== oldVal) {
			await fetchClient()
		}
	}
)

onMounted(async () => {
	// Прогрев глобального кеша структуры адреса
	auxStore().getAddressContainerStructure()
	await fetchClient()
})

const loaderStyle = computed(() => ({
	'background-color': 'rgba(255, 255, 255, 0.5)'
}))

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "client-page",
      ref_key: "$clientPage",
      ref: $clientPage
    }, [
      (isClientLoading.value)
        ? (_openBlock(), _createBlock(AppLoader, {
            key: 0,
            style: _normalizeStyle(loaderStyle.value)
          }, null, 8, ["style"]))
        : _createCommentVNode("", true),
      _createVNode(AppScrollTopButton, {
        class: "client-page__scroll-top",
        enabled: _unref(isScrollTopEnabled),
        onOnClick: _unref(scrollToTop)
      }, null, 8, ["enabled", "onOnClick"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(client.value?.Creator.Name || _ctx.$t('user_label')), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(client.value ? getCreatedDate(client.value.CreateTime) : ''), 1),
          (client.value?.CanBeDeleted && _unref(clientStore).client?.DeleteAccess!==0)
            ? (_openBlock(), _createBlock(AppResizableDropdown, {
                key: 0,
                ref_key: "$deleteClient",
                ref: $deleteClient,
                position: "right",
                "centered-on-mobile": "",
                "close-by-click-outside": true,
                name: "$deleteClient"
              }, {
                activator: _withCtx(() => [
                  _createVNode(AppTooltip, {
                    text: _ctx.$t('remove')
                  }, {
                    activator: _withCtx(() => [
                      _createVNode(AppIcon, {
                        class: "client-page__header-person-icon",
                        name: "delete-outline",
                        width: "18px",
                        color: "#979797",
                        "hover-color": "#BA4C4C",
                        cursor: "pointer"
                      })
                    ]),
                    _: 1
                  }, 8, ["text"])
                ]),
                default: _withCtx(() => [
                  _createVNode(DeleteClientConfirmDropdown, {
                    loading: isClientLoading.value,
                    onCancel: _cache[0] || (_cache[0] = ($event: any) => ($deleteClient.value?.close())),
                    onConfirm: onConfirmDelete
                  }, null, 8, ["loading"])
                ]),
                _: 1
              }, 512))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(AppTooltip, {
            text: _ctx.$t(client.value?.Favorite ? 'favourite_remove' : 'add_to_favorites')
          }, {
            activator: _withCtx(() => [
              _createVNode(AppIcon, {
                class: "client-page__header-options-icon",
                name: "favourite",
                width: "18px",
                color: client.value?.Favorite ? '#D05A4F' : '#979797',
                "hover-color": client.value?.Favorite ? '#979797' : '#D05A4F',
                cursor: "pointer",
                onClick: toggleFavourite
              }, null, 8, ["color", "hover-color"])
            ]),
            _: 1
          }, 8, ["text"]),
          _createVNode(AppTooltip, {
            ref_key: "$shareTooltip",
            ref: $shareTooltip,
            text: shareTooltipText.value
          }, {
            activator: _withCtx(() => [
              _createVNode(AppIcon, {
                class: "client-page__header-options-icon",
                style: { marginTop: '1px' },
                name: "share",
                width: "18px",
                color: "#979797",
                "hover-color": "#499259",
                cursor: "pointer",
                onClick: onCopyClientRoute
              })
            ]),
            _: 1
          }, 8, ["text"]),
          (_unref(clientStore).client?.AccessLevel!==0)
            ? (_openBlock(), _createBlock(AppResizableDropdown, {
                key: 0,
                ref_key: "$addTag",
                ref: $addTag,
                position: "right",
                "close-by-click-outside": true,
                "max-width": 640,
                "max-height": 460,
                "mobile-title": _ctx.$t('choose_tags'),
                name: "$addTagClientPage"
              }, {
                activator: _withCtx(() => [
                  _createVNode(AppTooltip, {
                    text: _ctx.$t('file_add_tag')
                  }, {
                    activator: _withCtx(() => [
                      _createVNode(AppIcon, {
                        class: "client-page__header-options-icon",
                        name: "hash",
                        width: "18px",
                        color: "#979797",
                        "hover-color": "#499259",
                        cursor: "pointer"
                      })
                    ]),
                    _: 1
                  }, 8, ["text"])
                ]),
                default: _withCtx(() => [
                  _createVNode(AppTagSelector, {
                    "model-value": clientTagsModel.value,
                    "entity-type": _unref(TagEntityType).Client,
                    mode: "select",
                    "allow-create": "",
                    "onUpdate:modelValue": onSelectorChange,
                    onCreateTag: onCreateTag,
                    onClose: _cache[1] || (_cache[1] = ($event: any) => ($addTag.value?.close()))
                  }, null, 8, ["model-value", "entity-type"])
                ]),
                _: 1
              }, 8, ["mobile-title"]))
            : (_openBlock(), _createBlock(AppIcon, {
                key: 1,
                class: "client-page__header-options-icon",
                name: "hash",
                width: "18px",
                color: "#D2D2D2"
              })),
          (client.value?.Tags?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(client.value.Tags, (tag) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: tag.Id,
                    class: "client-page__header-options-tags-item"
                  }, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(tag.Name.toLowerCase()), 1),
                    (_unref(clientStore).client?.AccessLevel!==0)
                      ? (_openBlock(), _createBlock(AppTooltip, {
                          key: 0,
                          text: _ctx.$t('ui_tag_detach')
                        }, {
                          activator: _withCtx(() => [
                            _createVNode(AppIcon, {
                              class: "client-page__direction-aw-left-icon",
                              style: { marginTop: '-2px' },
                              name: "close-bold",
                              width: "12px",
                              color: "#D2D2D2",
                              "hover-color": "#BA4C4C",
                              cursor: "pointer",
                              onClick: ($event: any) => (onDetachTag(tag.Id))
                            }, null, 8, ["onClick"])
                          ]),
                          _: 2
                        }, 1032, ["text"]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (hasAnyRestrictedAccess.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(AppIcon, {
              class: "client-page__header-permition-icon",
              name: "invalid",
              width: "16px",
              color: "#979797"
            }),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('client_limited_access')), 1)
          ]))
        : _createCommentVNode("", true),
      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "client-page__divider" }, null, -1)),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          (_unref(clientStore).client?.AccessLevel==1)
            ? (_openBlock(), _createBlock(AppTooltip, {
                key: 0,
                text: _ctx.$t('info')
              }, {
                activator: _withCtx(() => [
                  _createVNode(AppIcon, {
                    class: "client-page__client-icon",
                    style: { marginTop: '-2px' },
                    name: "info-circle-outline",
                    width: "18px",
                    color: "#979797",
                    "hover-color": "#499259",
                    cursor: "pointer",
                    onClick: openClientInfoModal
                  })
                ]),
                _: 1
              }, 8, ["text"]))
            : (_openBlock(), _createBlock(AppIcon, {
                key: 1,
                class: "client-page__client-icon",
                style: { marginTop: '-2px' },
                name: "info-circle-outline",
                width: "18px",
                color: "#D2D2D2"
              }))
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createTextVNode(_toDisplayString(_ctx.$t('client_label')) + _toDisplayString(_unref(clientStore).client?.NameAccess!==0 ? ':' : '') + " ", 1),
          (isClientNameEdited.value)
            ? (_openBlock(), _createBlock(FileInput, {
                key: 0,
                ref_key: "$clientNameInput",
                ref: $clientNameInput,
                modelValue: editedClientName.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((editedClientName).value = $event)),
                onBlur: saveClientName
              }, null, 8, ["modelValue"]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_unref(clientStore).client?.NameAccess!==0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(client.value?.Name || ''), 1))
                  : _createCommentVNode("", true),
                (_unref(clientStore).client?.NameAccess==2)
                  ? (_openBlock(), _createBlock(AppTooltip, {
                      key: 1,
                      class: "client-page__client-edit",
                      text: _ctx.$t('edit_label')
                    }, {
                      activator: _withCtx(() => [
                        _createVNode(AppIcon, {
                          class: "client-page__client-icon",
                          style: { marginTop: '-2px' },
                          name: "edit-pencil",
                          width: "18px",
                          color: "#979797",
                          "hover-color": "#499259",
                          cursor: "pointer",
                          onClick: editClientName
                        })
                      ]),
                      _: 1
                    }, 8, ["text"]))
                  : _createCommentVNode("", true)
              ], 64))
        ])
      ]),
      _cache[19] || (_cache[19] = _createElementVNode("div", { class: "client-page__divider" }, null, -1)),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(AppIcon, {
            class: "client-page__address-icon",
            style: { marginTop: '-2px' },
            name: "address",
            width: "18px",
            color: _unref(clientStore).client?.AddressAccess==2 ? '#979797' : '#D2D2D2'
          }, null, 8, ["color"])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createTextVNode(_toDisplayString(_ctx.$t('address_upcase')) + _toDisplayString(_unref(clientStore).client?.AddressAccess!==0 ? ':' : '') + " ", 1),
          (_unref(clientStore).client?.AddressAccess !== 0)
            ? (_openBlock(), _createBlock(InlineAddressEditor, {
                id: 'client-address',
                key: client.value?.Id,
                "model-value": clientAddressContainer.value,
                editable: _unref(clientStore).client?.AddressAccess === 2,
                "show-empty-placeholder": false,
                onSave: onClientAddressSave
              }, null, 8, ["model-value", "editable"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "client-page__divider" }, null, -1)),
      (canViewCounterparties.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                (canEditCounterparties.value)
                  ? (_openBlock(), _createBlock(AppResizableDropdown, {
                      key: 0,
                      position: "right",
                      resizable: "",
                      "initial-width": 600,
                      "initial-height": 630,
                      "min-width": 440,
                      "max-width": 900,
                      "min-height": 480,
                      "max-height": 900,
                      "close-by-click-outside": counterpartyDropdownMode.value === 'search' && !isCpInfoOpen.value,
                      "mobile-title": _ctx.$t('choose_counterparties'),
                      ref_key: "$addCounterparty",
                      ref: $addCounterparty,
                      name: "$addCounterparty",
                      onClose: _cache[4] || (_cache[4] = ($event: any) => (counterpartyDropdownMode.value = 'search'))
                    }, {
                      activator: _withCtx(() => [
                        _createVNode(AppTooltip, {
                          text: _ctx.$t('ui_add')
                        }, {
                          activator: _withCtx(() => [
                            _createVNode(AppIcon, {
                              class: "client-page__direction-header-icon",
                              name: "plus",
                              width: "15px",
                              color: "#979797",
                              "hover-color": "#499259",
                              cursor: "pointer"
                            })
                          ]),
                          _: 1
                        }, 8, ["text"])
                      ]),
                      default: _withCtx(() => [
                        (client.value)
                          ? (_openBlock(), _createBlock(ClientAddCounterpartyDropdown, {
                              key: 0,
                              "client-id": client.value.Id,
                              "added-counterparties": client.value.Counterparties ?? [],
                              "show-close-icon": "",
                              onModeChange: _cache[3] || (_cache[3] = ($event: any) => (counterpartyDropdownMode.value = $event)),
                              onOpenInfo: openCpInfo,
                              onClose: closeAddCounterpartyDropdown
                            }, null, 8, ["client-id", "added-counterparties"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["close-by-click-outside", "mobile-title"]))
                  : (_openBlock(), _createBlock(AppIcon, {
                      key: 1,
                      class: "client-page__direction-header-icon",
                      name: "plus",
                      width: "15px",
                      color: "#D2D2D2"
                    })),
                _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('client_counterparties_title')), 1),
                (_unref(isCpOverflowing))
                  ? (_openBlock(), _createBlock(AppTooltip, {
                      key: 2,
                      text: _ctx.$t('ui_fullscreen')
                    }, {
                      activator: _withCtx(() => [
                        _createVNode(AppIcon, {
                          class: "client-page__direction-header-icon",
                          name: "arrow-expand",
                          width: "18px",
                          color: "#979797",
                          "hover-color": "#499259",
                          cursor: "pointer",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => ($cpModal.value?.onOpen()))
                        })
                      ]),
                      _: 1
                    }, 8, ["text"]))
                  : _createCommentVNode("", true)
              ]),
              (client.value?.Counterparties.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createTextVNode(" [" + _toDisplayString(_ctx.$t('client_revenue_label')) + " ", 1),
                    _cache[10] || (_cache[10] = _createElementVNode("span", { style: {margin: '0 1px'} }, "/", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('client_debt_label')) + ": " + _toDisplayString(getTotalRevenue.value) + " ", 1),
                    _cache[11] || (_cache[11] = _createElementVNode("span", { style: {margin: '0 1px'} }, "/", -1)),
                    _createElementVNode("span", _hoisted_22, _toDisplayString(getTotalDebt.value), 1),
                    _cache[12] || (_cache[12] = _createTextVNode("] "))
                  ]))
                : _createCommentVNode("", true)
            ]),
            (client.value?.Counterparties && client.value?.Counterparties.length)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  ref_key: "$cpBody",
                  ref: $cpBody,
                  class: _normalizeClass({
					'client-page__direction-body': true,
					'client-page__direction-body--cp': true
				})
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(client.value.Counterparties, (cp, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: cp.Id,
                      class: "client-page__direction-cp"
                    }, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, _toDisplayString(index + 1) + ".", 1),
                        _createElementVNode("div", _hoisted_25, [
                          _createTextVNode(_toDisplayString(cp.Name), 1),
                          _createElementVNode("span", _hoisted_26, [
                            _cache[13] || (_cache[13] = _createTextVNode(" ")),
                            (cp.Instance1C)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode("[" + _toDisplayString(cp.Instance1C) + "] ", 1)
                                ], 64))
                              : _createCommentVNode("", true),
                            (canViewCounterparties.value)
                              ? (_openBlock(), _createBlock(AppTooltip, {
                                  key: 1,
                                  text: _ctx.$t('info')
                                }, {
                                  activator: _withCtx(() => [
                                    _createVNode(AppIcon, {
                                      class: "client-page__direction-cp-left-icon",
                                      style: { marginTop: '-2px' },
                                      name: "info-circle-outline",
                                      width: "14px",
                                      color: "#979797",
                                      "hover-color": "#499259",
                                      cursor: "pointer",
                                      onClick: ($event: any) => (openCpInfo(cp.Id))
                                    }, null, 8, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1032, ["text"]))
                              : _createCommentVNode("", true),
                            (canEditCounterparties.value)
                              ? (_openBlock(), _createBlock(AppResizableDropdown, {
                                  key: 2,
                                  position: "right",
                                  "close-by-click-outside": true,
                                  ref_for: true,
                                  ref: (el) => { if (el) $cpDetach.value[cp.Id] = el }
                                }, {
                                  activator: _withCtx(() => [
                                    _createVNode(AppTooltip, {
                                      text: _ctx.$t('remove')
                                    }, {
                                      activator: _withCtx(() => [
                                        _createVNode(AppIcon, {
                                          class: "client-page__direction-cp-left-icon",
                                          style: { marginTop: '-2px' },
                                          name: "close-bold",
                                          width: "12px",
                                          color: "#D2D2D2",
                                          "hover-color": "#BA4C4C",
                                          cursor: "pointer"
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["text"])
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(DetachCounterpartyConfirmDropdown, {
                                      onCancel: ($event: any) => ($cpDetach.value[cp.Id]?.close()),
                                      onConfirm: ($event: any) => (onDetachCounterparty(cp.Id))
                                    }, null, 8, ["onCancel", "onConfirm"])
                                  ]),
                                  _: 2
                                }, 1536))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createTextVNode(_toDisplayString(_unref(formatMoney)(cp.Revenue)), 1),
                        _cache[14] || (_cache[14] = _createElementVNode("span", { style: {margin: '0 1px'} }, "/", -1)),
                        _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(formatMoney)(cp.Debt)), 1)
                      ])
                    ]))
                  }), 128))
                ], 512))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (canViewCounterparties.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            (_unref(clientStore).client?.UnionAccess==2)
              ? (_openBlock(), _createBlock(AppResizableDropdown, {
                  key: 0,
                  position: "right",
                  resizable: "",
                  "initial-width": 400,
                  "initial-height": 450,
                  "min-width": 400,
                  "max-width": 800,
                  "min-height": 450,
                  "max-height": 900,
                  "mobile-title": _ctx.$t('choose_holding'),
                  ref_key: "$addUnionClient",
                  ref: $addUnionClient,
                  name: "$addUnionClient"
                }, {
                  activator: _withCtx(() => [
                    _createVNode(AppTooltip, {
                      text: _ctx.$t('ui_add')
                    }, {
                      activator: _withCtx(() => [
                        _createVNode(AppIcon, {
                          class: "client-page__direction-header-icon",
                          name: "plus",
                          width: "15px",
                          color: "#979797",
                          "hover-color": "#499259",
                          cursor: "pointer"
                        })
                      ]),
                      _: 1
                    }, 8, ["text"])
                  ]),
                  default: _withCtx(() => [
                    (client.value)
                      ? (_openBlock(), _createBlock(ClientAddUnionDropdown, {
                          key: 0,
                          "client-id": client.value.Id,
                          "added-clients": client.value.UnionClients,
                          "show-close-icon": "",
                          onClose: closeAddUnionDropdown
                        }, null, 8, ["client-id", "added-clients"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["mobile-title"]))
              : (_unref(clientStore).client?.UnionAccess!==2)
                ? (_openBlock(), _createBlock(AppIcon, {
                    key: 1,
                    class: "client-page__direction-header-icon",
                    name: "plus",
                    width: "15px",
                    color: "#D2D2D2"
                  }))
                : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t('holding')), 1),
            (_unref(isHoldingOverflowing) && _unref(clientStore).client?.UnionAccess!==0)
              ? (_openBlock(), _createBlock(AppTooltip, {
                  key: 2,
                  text: _ctx.$t('ui_fullscreen')
                }, {
                  activator: _withCtx(() => [
                    _createVNode(AppIcon, {
                      class: "client-page__direction-header-icon",
                      name: "arrow-expand",
                      width: "18px",
                      color: "#979797",
                      "hover-color": "#499259",
                      cursor: "pointer",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => ($holdingModal.value?.onOpen()))
                    })
                  ]),
                  _: 1
                }, 8, ["text"]))
              : _createCommentVNode("", true)
          ]),
          (client.value?.UnionClients.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _createTextVNode(" [" + _toDisplayString(_ctx.$t('client_revenue_label')) + " ", 1),
                _cache[15] || (_cache[15] = _createElementVNode("span", { style: {margin: '0 1px'} }, "/", -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('client_debt_label')) + ": " + _toDisplayString(_unref(formatMoney)(client.value?.UnionRevenue)) + " ", 1),
                _cache[16] || (_cache[16] = _createElementVNode("span", { style: {margin: '0 1px'} }, "/", -1)),
                _createElementVNode("span", _hoisted_35, _toDisplayString(_unref(formatMoney)(client.value?.UnionDebt)), 1),
                _cache[17] || (_cache[17] = _createTextVNode("] "))
              ]))
            : _createCommentVNode("", true)
        ]),
        (client.value?.UnionClients && client.value?.UnionClients.length && _unref(clientStore).client?.UnionAccess!==0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              ref_key: "$holdingBody",
              ref: $holdingBody,
              class: _normalizeClass({
					'client-page__direction-body': true,
					'client-page__direction-body--uc': true
				})
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(client.value.UnionClients, (uc, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: uc.Id,
                  class: "client-page__direction-uc"
                }, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, _toDisplayString(index + 1) + ".", 1),
                    _createElementVNode("div", _hoisted_38, [
                      _createVNode(_component_router_link, {
                        class: "client-page__direction-uc-left-name-str",
                        to: { query: { page: 'client', id: uc.Id } }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(uc.Name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      _createElementVNode("span", _hoisted_39, [
                        _createTextVNode(" (" + _toDisplayString(uc.Address) + ") ", 1),
                        (_unref(clientStore).client?.UnionAccess==2)
                          ? (_openBlock(), _createBlock(AppTooltip, {
                              key: 0,
                              text: _ctx.$t('remove')
                            }, {
                              activator: _withCtx(() => [
                                _createVNode(AppIcon, {
                                  class: "client-page__direction-uc-left-icon",
                                  style: { marginTop: '-2px' },
                                  name: "close-bold",
                                  width: "12px",
                                  color: "#D2D2D2",
                                  "hover-color": "#BA4C4C",
                                  cursor: "pointer",
                                  onClick: ($event: any) => (onDetachUnionClient(uc.Id))
                                }, null, 8, ["onClick"])
                              ]),
                              _: 2
                            }, 1032, ["text"]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ], 512))
          : _createCommentVNode("", true)
      ]),
      _cache[21] || (_cache[21] = _createElementVNode("div", { class: "client-page__divider" }, null, -1)),
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            (_unref(clientStore).client?.AttachedWorkersAccess==2)
              ? (_openBlock(), _createBlock(AppResizableDropdown, {
                  key: 0,
                  position: "right",
                  resizable: "",
                  "initial-width": 400,
                  "initial-height": 450,
                  "min-width": 400,
                  "max-width": 800,
                  "min-height": 450,
                  "max-height": 900,
                  "mobile-title": _ctx.$t('choose_workers'),
                  ref_key: "$addWorker",
                  ref: $addWorker,
                  name: "$addWorker"
                }, {
                  activator: _withCtx(() => [
                    _createVNode(AppTooltip, {
                      text: _ctx.$t('ui_add')
                    }, {
                      activator: _withCtx(() => [
                        _createVNode(AppIcon, {
                          class: "client-page__direction-header-icon",
                          name: "plus",
                          width: "15px",
                          color: "#979797",
                          "hover-color": "#499259",
                          cursor: "pointer"
                        })
                      ]),
                      _: 1
                    }, 8, ["text"])
                  ]),
                  default: _withCtx(() => [
                    (client.value)
                      ? (_openBlock(), _createBlock(ClientAddWorkerDropdown, {
                          key: 0,
                          "client-id": client.value.Id,
                          "added-workers": client.value.AttachedWorkers,
                          "show-close-icon": "",
                          onClose: closeAddWorkerDropdown
                        }, null, 8, ["client-id", "added-workers"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["mobile-title"]))
              : (_openBlock(), _createBlock(AppIcon, {
                  key: 1,
                  class: "client-page__direction-header-icon",
                  name: "plus",
                  width: "15px",
                  color: "#D2D2D2"
                })),
            _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.$t('client_workers')), 1)
          ])
        ]),
        (client.value?.AttachedWorkers && client.value?.AttachedWorkers.length && _unref(clientStore).client?.AttachedWorkersAccess!==0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(client.value.AttachedWorkers, (aw, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: aw.Id,
                  class: "client-page__direction-aw"
                }, [
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, _toDisplayString(index + 1) + ".", 1),
                    _createElementVNode("div", {
                      class: _normalizeClass({
							'client-page__direction-aw-left-name': true,
							'client-page__direction-aw-left-name--removed': aw.Removed,
						})
                    }, [
                      _createTextVNode(_toDisplayString(aw.Name) + " ", 1),
                      (_unref(clientStore).client?.AttachedWorkersAccess==2)
                        ? (_openBlock(), _createBlock(AppTooltip, {
                            key: 0,
                            text: _ctx.$t('remove')
                          }, {
                            activator: _withCtx(() => [
                              _createVNode(AppIcon, {
                                class: "client-page__direction-aw-left-icon",
                                style: { marginTop: '-2px' },
                                name: "close-bold",
                                width: "12px",
                                color: "#D2D2D2",
                                "hover-color": "#BA4C4C",
                                cursor: "pointer",
                                onClick: ($event: any) => (onDetachWorker(aw.Id))
                              }, null, 8, ["onClick"])
                            ]),
                            _: 2
                          }, 1032, ["text"]))
                        : _createCommentVNode("", true),
                      (_unref(clientStore).client?.AttachedWorkersAccess==2)
                        ? (_openBlock(), _createBlock(AppResizableDropdown, {
                            key: 1,
                            position: "right",
                            "initial-width": 400,
                            "initial-height": 450,
                            "min-width": 400,
                            "max-width": 800,
                            "min-height": 450,
                            "max-height": 900,
                            "mobile-title": _ctx.$t('choose_roles'),
                            ref_for: true,
                            ref: (el) => { if (el) $addRoles.value[aw.Id] = el }
                          }, {
                            activator: _withCtx(() => [
                              _createVNode(AppTooltip, {
                                text: _ctx.$t('client_add_role')
                              }, {
                                activator: _withCtx(() => [
                                  _createVNode(AppIcon, {
                                    class: "client-page__direction-aw-left-icon",
                                    style: { marginTop: '-2px' },
                                    name: "hash",
                                    width: "18px",
                                    color: "#979797",
                                    "hover-color": "#499259",
                                    cursor: "pointer"
                                  })
                                ]),
                                _: 1
                              }, 8, ["text"])
                            ]),
                            default: _withCtx(() => [
                              (client.value)
                                ? (_openBlock(), _createBlock(ClientAddRoleDropdown, {
                                    key: 0,
                                    "client-id": client.value.Id,
                                    "worker-id": aw.Id,
                                    "attached-roles": aw.Roles ?? [],
                                    "show-close-icon": "",
                                    onClose: ($event: any) => (closeAddRoleDropdown(aw.Id))
                                  }, null, 8, ["client-id", "worker-id", "attached-roles", "onClose"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["mobile-title"]))
                        : (_openBlock(), _createBlock(AppIcon, {
                            key: 2,
                            class: "client-page__direction-aw-left-icon",
                            style: { marginTop: '-2px' },
                            name: "hash",
                            width: "18px",
                            color: "#D2D2D2"
                          })),
                      (aw.Roles?.length)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_47, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aw.Roles, (role) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: role.Id,
                                class: "client-page__direction-aw-left-roles-item"
                              }, [
                                _createElementVNode("span", _hoisted_48, _toDisplayString(role.Name), 1),
                                (_unref(clientStore).client?.AttachedWorkersAccess==2)
                                  ? (_openBlock(), _createBlock(AppTooltip, {
                                      key: 0,
                                      text: _ctx.$t('remove')
                                    }, {
                                      activator: _withCtx(() => [
                                        _createVNode(AppIcon, {
                                          class: "client-page__direction-aw-left-icon",
                                          style: { marginTop: '-2px' },
                                          name: "close-bold",
                                          width: "12px",
                                          color: "#D2D2D2",
                                          "hover-color": "#BA4C4C",
                                          cursor: "pointer",
                                          onClick: ($event: any) => (onDetachRole(aw.Id, role.Id))
                                        }, null, 8, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1032, ["text"]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ], 2)
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _cache[22] || (_cache[22] = _createElementVNode("div", { class: "client-page__divider" }, null, -1)),
      (_unref(clientStore).client?.ParameterAccess==1 || _unref(clientStore).client?.ParameterAccess==2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                (_unref(clientStore).client?.ParameterAccess==2)
                  ? (_openBlock(), _createBlock(AppTooltip, {
                      key: 0,
                      text: _ctx.$t('ui_add')
                    }, {
                      activator: _withCtx(() => [
                        _createElementVNode("span", {
                          ref_key: "parametersAddAnchor",
                          ref: parametersAddAnchor,
                          class: "client-page__direction-header-add-anchor",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (parametersAddOpen.value = true))
                        }, [
                          _createVNode(AppIcon, {
                            class: "client-page__direction-header-icon",
                            name: "plus",
                            width: "15px",
                            color: "#979797",
                            "hover-color": "#499259",
                            cursor: "pointer"
                          })
                        ], 512)
                      ]),
                      _: 1
                    }, 8, ["text"]))
                  : (_openBlock(), _createBlock(AppIcon, {
                      key: 1,
                      class: "client-page__direction-header-icon",
                      name: "plus",
                      width: "15px",
                      color: "#D2D2D2"
                    })),
                _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.$t('parameters_label')), 1)
              ])
            ]),
            (client.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                  _createVNode(ParametersSection, {
                    "entity-id": clientId.value,
                    "attachment-type": _unref(V2ParameterAttachmentType).Client,
                    "parameter-access": _unref(clientStore).client?.ParameterAccess,
                    "add-menu-target": parametersAddAnchor.value,
                    "add-menu-open": parametersAddOpen.value,
                    "onUpdate:addMenuOpen": _cache[8] || (_cache[8] = ($event: any) => ((parametersAddOpen).value = $event)),
                    onChanged: fetchClient
                  }, null, 8, ["entity-id", "attachment-type", "parameter-access", "add-menu-target", "add-menu-open"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _cache[23] || (_cache[23] = _createElementVNode("div", { class: "client-page__divider" }, null, -1)),
      _createElementVNode("div", _hoisted_54, [
        (_unref(clientStore).client?.FileAccess!==0)
          ? (_openBlock(), _createBlock(FileBlock, {
              key: 0,
              id: clientId.value,
              "root-name": client.value?.Name,
              type: "client",
              "rule-access": _unref(clientStore).client?.FileAccess
            }, null, 8, ["id", "root-name", "rule-access"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(ClientInfoModal, {
        ref_key: "$clientInfoModal",
        ref: $clientInfoModal,
        title: _ctx.$t('client_information_and_access')
      }, null, 8, ["title"]),
      _createVNode(HoldingExpandModal, {
        ref_key: "$holdingModal",
        ref: $holdingModal
      }, null, 512),
      _createVNode(CounterpartiesExpandModal, {
        ref_key: "$cpModal",
        ref: $cpModal
      }, null, 512),
      _createVNode(CounterpartyInfoModal, {
        ref_key: "$cpInfoModal",
        ref: $cpInfoModal,
        onClose: _cache[9] || (_cache[9] = ($event: any) => (isCpInfoOpen.value = false))
      }, null, 512)
    ], 512),
    (_unref(clientStore).client?.FileAccess==0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_57, [
                _createVNode(AppIcon, {
                  class: "client-page__direction-permition-icon",
                  name: "invalid",
                  width: "24px",
                  color: "#979797"
                }),
                _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.$t('client_files_no_access')), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})